// extracted by mini-css-extract-plugin
export default {"heading":"RegisterConfirmed_heading__i1K+n","forwardButton":"RegisterConfirmed_forwardButton__UNADh"};